import { ApiCall } from '../helper/axios';
const BASE = '/api/clockify-goals';
const clockifyGoalService = {
    listGoals(token) {
        return ApiCall('GET', BASE, '', { Authorization: token || '' });
    },
    createGoal(payload, token) {
        return ApiCall('POST', BASE, payload, { Authorization: token || '' });
    },
    updateGoal(id, payload, token) {
        return ApiCall('PUT', `${BASE}/${id}`, payload, { Authorization: token || '' });
    },
    deleteGoal(id, token) {
        return ApiCall('DELETE', `${BASE}/${id}`, '', { Authorization: token || '' });
    },
};
/** Server message of a failed call (ApiCall returns the AxiosError on non-2xx), or the fallback. */
export const goalErrorMessage = (res, fallback) => {
    const msg = res?.response?.data?.message ?? res?.data?.message;
    if (!msg || /^Request failed with status code/i.test(msg))
        return fallback;
    return msg;
};
/** Per-field validation errors from a 422. */
export const goalFieldErrors = (res) => res?.response?.data?.data?.errors ?? res?.data?.data?.errors ?? [];
export default clockifyGoalService;
